import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-typography',
  templateUrl: './typography.component.html',
  styleUrls: ['./typography.component.css'],
  standalone: false
})
export class TypographyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
